import VideoPlayer from './../shared/videoPlayer';
import { setCookie, getCookie } from './../shared/cookieHelper';
import LockCollateralStatusSignalR from './../shared/lockCollateralStatusSignalR';

const builderSpecVideoGenerationTimeout = 300; //in seconds

$(function () {
    if ($('#speclock_confirmation_page').length) {
        $(document).ready(function () {
            var $loading = $('#ll_loading-div').hide();
            var button = $('#attach-button');
            var input = $('#attach-input');
            var logobutton = $('#logo-attach-button');
            var logoinput = $('#logo-attach-input');
            var form = new FormData();
            form.append("loan-number", $("#loan-number").val());

            $("#new_builder_phonenumber").inputmask("(999) 999-9999", { clearIncomplete: true });

            var loc1 = getCookie("speclock_prefix_url");

            var exist = $("#hdnNoExist").val();
            $("#fico-div").hide();
            $("#featured-button-div").hide();

            if (!exist) {
                $.ajax({
                    url: 'generate-flyer-confirmation',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $("#openimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                    },
                    success: function (response) {
                        if (response != "") {
                            response = response.replace("/upload/", "/upload/fl_attachment:OpenFlyer/")
                            $("#openlink").attr("href", response);
                            $("#openimg").attr("src", response.replace(".pdf", ".png"));
                        }
                    }
                });

                $.ajax({
                    url: 'generate-flyer-speclock',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $("#slopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                    },
                    success: function (response) {
                        if (response != "") {
                            response = response.replace("/upload/", "/upload/fl_attachment:PromoFlyer/")
                            $("#slopenlink").attr("href", response);
                            $("#slopenimg").attr("src", response.replace(".pdf", ".png"));
                        }
                    }
                });
                $.ajax({
                    url: 'generate-builder-socialPMT',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $("#socialpmtopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                    },
                    success: function (response) {
                        if (response != "") {
                            response = response.replace("/upload/", "/upload/fl_attachment:SocialPost/")
                            $("#socialpmtopenlink").attr("href", response);
                            $("#socialpmtopenimg").attr("src", response.replace(".pdf", ".png"));
                        }
                    }
                });

                $.ajax({
                    url: 'generate-featured-rate-post',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $("#educationpostimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                    },
                    success: function (response) {
                        if (response != "") {
                            response = response.replace("/upload/", "/upload/fl_attachment:FeaturedRatePost/")
                            $("#educationpostlink").attr("href", response);
                            $("#educationpostimg").attr("src", response.replace(".pdf", ".png"));
                        }
                    }
                });

                var formnew = new FormData();
                formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", $("#hdnLP").val());
                LoadDownpayments(formnew);
            }

            $('#new-loanprogram').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                var textSelected = optionSelected.text()

                var formnew = new FormData();
                formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", textSelected);

                LoadDownpayments(formnew);
            });

            function LoadDownpayments(formnew)
            {
                $.ajax({
                    url: 'get-downpayments-for-loanprogram',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formnew,
                    beforeSend: function () {
                        $("#loading-img-featured").removeClass("d-none");
                    },
                    success: function (response) {
                        $("#loading-img-featured").addClass("d-none");
                        if (response.success) {
                            $('#new-downpayment').empty();
                            $('#new-downpayment').append(new Option("-select-", ""));
                            for (var i = 0; i < response.data.length; i++) {
                                $('#new-downpayment').append(new Option((response.data[i] * 100).toFixed(2).toString(), response.data[i]));
                            }
                        }
                    }
                });
            }

            $('#new-downpayment').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                var textSelected = optionSelected.text()

                var formnew = new FormData();
                formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", $("#new-loanprogram").val());
                formnew.append("down-payment", valueSelected);

                $.ajax({
                    url: 'get-ficoscores-for-loanprogram',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formnew,
                    beforeSend: function () {
                        $("#loading-img-featured").removeClass("d-none");
                    },
                    success: function (response) {
                        $("#loading-img-featured").addClass("d-none");
                        if (response.success) {
                            $("#fico-div").show();
                            $("#featured-button-div").show();
                            $('#new-fico').empty();
                            $('#new-fico').append(new Option("-select-", ""));
                            for (var i = 0; i < response.data.length; i++) {
                                $('#new-fico').append(new Option(response.data[i].key, response.data[i].value));
                            }
                        }
                    }
                });
            });

            $('#new-fico').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                var textSelected = optionSelected.text()

                var formnew = new FormData();
                formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", $("#new-loanprogram").val());
                formnew.append("down-payment", $('#new-downpayment option:selected').val());
                formnew.append("fico-scores", textSelected);

                $.ajax({
                    url: 'get-loan-program-code',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formnew,
                    beforeSend: function () {
                        $("#loading-img-featured").removeClass("d-none");
                    },
                    success: function (response) {
                        $("#loading-img-featured").addClass("d-none");
                        if (response.success) {
                            $("#hdnloanprogramcode").val(response.data);
                        }
                    }
                });
            });

            function BuildFormData(files) {
                var data = new FormData();
                data.append("loan-number", $("#loan-number").val());

                for (var i = 0; i < files.length; i++) {
                    data.append(files[i].name, files[i]);
                }

                return data;
            }

            function PostData(url, data) {
                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#instructions-div p').removeClass('upload-error');

                        $('[download="CustomVideo"], [download="VideoQRCode"]').parent().addClass('d-none');
                        $('#instructions-div p').text('Please wait while we generate your customized property video. It might take up to 5 minutes');
                        $('#instructions-div').removeClass('d-none');

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').addClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').removeClass('d-none');

                        $('#instructions-edu-div p').removeClass('upload-error');

                        $('[download="CustomVideo1"]').parent().addClass('d-none');
                        $('#instructions-edu-div p').text('Please wait while we generate your customized property video. It might take up to 5 minutes');
                        $('#instructions-edu-div').removeClass('d-none');

                        $('#educational_video_placeholder, #educational_video').addClass('d-none');
                        $('#educational_video_loading').removeClass('d-none');

                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            window.location.href = window.location.origin + window.location.pathname + '?id=' + $("#loan-number").val();
                            return;
                        }

                        console.error('Server error:', result.error);

                        $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');

                        $('#instructions-edu-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                        $('#educational_video_placeholder, #educational_video').removeClass('d-none');
                        $('#educational_video_loading').addClass('d-none');
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.error('Ajax error. Status: ' + textStatus + ' error: ' + errorThrown);

                        $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');
                        $('#instructions-edu-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');

                        $('#educational_video_placeholder, #educational_video').removeClass('d-none');
                        $('#educational_video_loading').addClass('d-none');
                    }
                });
            }

            button.on('click', function (e) {
                e.preventDefault();
                input.click();
            });

            logobutton.on('click', function (e) {
                e.preventDefault();
                logoinput.click();
            });

            input.on('change', async function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-listing-image';

                // SOLUTION: Ensure SignalR is ready with handlers BEFORE upload
                try {
                    if (!videoStatusHub) {
                        createVideoSignalR();
                    }

                    if (!handlersRegistered) {
                        registerVideoHandlers();
                    }

                    if (!videoStatusHub.isConnected()) {
                        await initializeVideoSignalRConnection();
                    }
                } catch (error) {
                    console.error('Failed to initialize SignalR before upload:', error);
                }

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $("#listing-image-form").addClass("d-none");
                        $("#form-listing-image").addClass("d-none");
                        $("#loading-img-listing").removeClass("d-none");
                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            // FIX: Update listing image IMMEDIATELY with the new URL from server response
                            // This ensures user sees new image before page reload, avoiding cached image display
                            if (result.listingImageUrl && result.listingImageVersion) {
                                var freshImageUrl = result.listingImageUrl;

                                // Ensure _final version (with badge overlay)
                                if (!freshImageUrl.includes('_final')) {
                                    var lastDot = freshImageUrl.lastIndexOf('.');
                                    if (lastDot > 0) {
                                        freshImageUrl = freshImageUrl.substring(0, lastDot) + '_final' + freshImageUrl.substring(lastDot);
                                    }
                                }

                                // Add cache-busting parameter
                                freshImageUrl += '?v=' + result.listingImageVersion;

                                // Update image immediately
                                $('#listing_image').prop('src', freshImageUrl);

                            }


                            // Add 1.5 second delay before reload to allow:
                            // 1. Database transaction to fully commit
                            // 2. Entity Framework cache to clear
                            // 3. Rate service to stabilize after potential concurrent requests
                            setTimeout(function() {
                                var currentUrl = new URL(window.location.href);
                                currentUrl.searchParams.set('id', $("#loan-number").val());
                                currentUrl.searchParams.set('videos_generating', 'true');
                                window.location.href = currentUrl.toString();
                            }, 1500);
                            return;
                        }

                        console.error('Server error:', result.error);
                        $("#form-listing-image").removeClass("d-none");
                        $("#listing-image-form").removeClass("d-none");
                        $("#loading-img-listing").addClass("d-none");
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.error("Listing image upload failed. Status: " + textStatus + ", Error: " + errorThrown);
                        $("#form-listing-image").removeClass("d-none");
                        $("#listing-image-form").removeClass("d-none");
                        $("#loading-img-listing").addClass("d-none");
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'));
                        $('#listing_image_upload_error').removeClass('d-none');
                    }
                });
            });

            logoinput.on('change', function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-builder-logo';

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#loading-builderlogo').removeClass('d-none');
                        $("#builder-logo-form").addClass("d-none");
                    },
                    success: function (result) {
                        if (result.success) {
                            window.location.href = window.location.origin + window.location.pathname + '?id=' + $("#loan-number").val();
                            return;
                        }

                        console.error('Server error:', result.error);
                        $("#builder-logo-form").removeClass("d-none");
                        $('#loading-builderlogo').addClass('d-none');
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.error('Ajax error. Status: ' + textStatus + ' error: ' + errorThrown);

                        $('#loading-builderlogo').addClass('d-none');
                    }
                });
            });

            $('#buttonSendMarketingCollateral').click(function (e) {
                e.preventDefault();

                var data = new FormData();
                data.append("loan-number", $("#loan-number").val());
                data.append("builder-email", $("#builder-email").val());
                $.ajax({
                    url: window.location.origin + window.location.pathname + '/send-marketing-collateral',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        if (response.success) {

                            return;
                        }
                    }
                });
            });

            $('#new_sales_price').on('focus', function (e) {
                if ($(this).val() === '$0') {
                    $(this).val('');
                }
            });

            $('#new_sales_price').on('keyup change', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var filteredValue = $(this).val().replace(/\D/g, '');
                if (!filteredValue) {
                    $(this).val('$0');
                    return;
                }

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));
                var newValue = Number(filteredValue);
                $(this).val(newValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }));

                if (Math.abs(1 - newValue / curValue) < 0.25) {
                    $('#update_price').prop("disabled", false);
                }
                else {
                    $('#update_price').prop("disabled", true);
                }
            });

            $('#new_sales_price').on('blur', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var newValue = Number($('#new_sales_price').val().replace(/\D/g, ''));
                if (newValue == 0)
                    return;

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));

                if (Math.abs(1 - newValue / curValue) > 0.25) {
                    $('#price_error_message').removeClass('d-none');
                    $('#update_price').prop("disabled", true);
                }
                else {
                    $('#price_error_message').addClass('d-none');
                    $('#update_price').prop("disabled", false);
                }
            });

            $('#update_price, #revert_original_price').on('click', function (e) {
                $('#price_change_form').parent().addClass('d-none');
                $('#loading-img-price').removeClass('d-none');

                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_price'
                    ? `update-price?loanNumber=${confirmationNumber}&newPrice=${Number($('#new_sales_price').val().replace(/\D/g, ''))}`
                    : `update-price?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function () {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#update_price_error_message').removeClass('d-none');

                        $('#price_change_form').parent().removeClass('d-none');
                        $('#loading-img-price').addClass('d-none');
                    });
            });

            $('#new_concession').on('keyup change blur', function (e) {
                $('#concession_error_message').addClass('d-none');
                $('#concession_update_error_message').addClass('d-none');

                var value = Number($(this).val());
                if (value >= 0.5 && value <= 6) {
                    $('#update_builder_concession').prop("disabled", false);
                }
                else {
                    $('#update_builder_concession').prop("disabled", true);
                    $('#concession_error_message').removeClass('d-none');
                }
            });

            $('#update_builder_concession').on('click', function (e) {
                $('#concession_change_form').parent().addClass('d-none');
                $('#loading-img-concession').removeClass('d-none');

                $('#concession_error_message').addClass('d-none');
                $('#concession_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_builder_concession'
                    ? `update-builder-concession?loanNumber=${confirmationNumber}&newConcession=${Number($('#new_concession').val())}`
                    : `update-builder-concession?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 500 && jqXHR.responseJSON && jqXHR.responseJSON.error === 'rates_unavailable') {
                            var el = $('#concession_update_error_message');
                            el.text(jqXHR.responseJSON.userMessage || 'Unable to calculate updated rates. Please contact your loan officer.');
                            el.removeClass('d-none').removeClass('alert-danger').addClass('alert-warning');
                        } else if (jqXHR.status === 0 || jqXHR.status === 502 || jqXHR.status === 503 || jqXHR.status === 504 || textStatus === 'timeout') {
                            var el = $('#concession_update_error_message');
                            el.text('The update is taking longer than expected. Your changes may have been saved \u2014 please refresh the page to check.');
                            el.removeClass('d-none').removeClass('alert-danger').addClass('alert-warning');
                        } else {
                            $('#concession_update_error_message').removeClass('d-none');
                        }
                        $('#concession_change_form').parent().removeClass('d-none');
                        $('#loading-img-concession').addClass('d-none');
                    });
            });

            $('#update_credit').on('click', function (e) {
                $('#update_credit').prop("disabled", true);
                $('#credit_change_form').parent().addClass('d-none');
                $('#loading-img-credit').removeClass('d-none');

                $('#credit_error_message').addClass('d-none');
                $('#credit_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_credit'
                    ? `update-credit?loanNumber=${confirmationNumber}&newCredit=${Number($('#new_credit').val())}&newCreditGov=${Number($('#new_credit_gov').val())}`
                    : `update-credit?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 500 && jqXHR.responseJSON && jqXHR.responseJSON.error === 'rates_unavailable') {
                            var el = $('#credit_update_error_message');
                            el.text(jqXHR.responseJSON.userMessage || 'Unable to calculate updated rates. Please contact your loan officer.');
                            el.removeClass('d-none').removeClass('alert-danger').addClass('alert-warning');
                        } else if (jqXHR.status === 0 || jqXHR.status === 502 || jqXHR.status === 503 || jqXHR.status === 504 || textStatus === 'timeout') {
                            var el = $('#credit_update_error_message');
                            el.text('The update is taking longer than expected. Your changes may have been saved \u2014 please refresh the page to check.');
                            el.removeClass('d-none').removeClass('alert-danger').addClass('alert-warning');
                        } else {
                            $('#credit_update_error_message').removeClass('d-none');
                        }
                        $('#credit_change_form').parent().removeClass('d-none');
                        $('#loading-img-credit').addClass('d-none');
                        $('#update_credit').prop("disabled", false);
                    });
            });

            $('#new_credit').on('keyup change blur', function (e) {
                $('#credit_error_message').addClass('d-none');
                $('#credit_update_error_message').addClass('d-none');
                var maxValue = Number($('#maxValue').val());
                var value = Number($(this).val());
                if (value >= 0 && value <= maxValue) {
                    var value1 = Number($('#new_credit_gov').val());
                    if (value1 >= 0 && value1 <= maxValue) {
                        $('#update_credit').prop("disabled", false);
                    }
                }
                else {
                    $('#update_credit').prop("disabled", true);
                    $('#credit_error_message').removeClass('d-none');
                }
            });

            $('#new_credit_gov').on('keyup change blur', function (e) {
                $('#credit_error_message').addClass('d-none');
                $('#credit_update_error_message').addClass('d-none');
                var maxValue = Number($('#maxValue').val());
                var value = Number($(this).val());
                if (value >= 0 && value <= maxValue) {
                    var value1 = Number($('#new_credit').val());
                    if (value1 >= 0 && value1 <= maxValue) {
                        $('#update_credit').prop("disabled", false);
                    }
                }
                else {
                    $('#update_credit').prop("disabled", true);
                    $('#credit_error_message').removeClass('d-none');
                }
            });

            $('#update_property_street').on('click', function (e) {
                var streetNumber = $('#new_streetnumber').val();
                var streetName = $('#new_streetname').val();

                if (!streetNumber.length || !streetName.length) {
                    $('#street_error_message').text('Please enter a valid street number and name').removeClass('d-none');
                    return;
                }

                $('#street_change_form').parent().addClass('d-none');
                $('#loading-img-street-change').removeClass('d-none');

                $('#street_error_message').addClass('d-none');
                $('#street_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_property_street'
                    ? `update-property-street?loanNumber=${confirmationNumber}&newStreetNumber=${$('#new_streetnumber').val()}&newStreetName=${$('#new_streetname').val()}`
                    : `update-property-street?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#street_update_error_message').removeClass('d-none');

                        $('#street_change_form').parent().removeClass('d-none');
                        $('#loading-img-street-change').addClass('d-none');
                    });
            });

            $('#update_builderinfo').on('click', function (e) {
                var companyName = $('#new_builder_companyname').val();
                var phoneNumber = $('#new_builder_phonenumber').val();
                var email = $('#new_builder_email').val();

                if (!companyName.length || !phoneNumber.length || !email.length) {
                    $('#builderinfo_error_message').text('Please enter valid builder information').removeClass('d-none');
                    return;
                }

                $('#builderinfo_change_form').parent().addClass('d-none');
                $('#loading-img-builderinfo-change').removeClass('d-none');

                $('#builderinfo_error_message').addClass('d-none');
                $('#builderinfo_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();
                                         
                $.post({
                    url: "update-builder-info?confirmation=" + $('#hdnConfirmationNumber').val(),
                    data: { companyName, phoneNumber, email },                    
                })
                .done(function (data, textStatus, jqXHR) {
                    location.reload();
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    $('#builderinfo_update_error_message').removeClass('d-none');
                    $('#builderinfo_change_form').parent().removeClass('d-none');
                    $('#loading-img-builderinfo-change').addClass('d-none');
                });
            });  

            $('#update_featured').click(function (e) {
                e.preventDefault();
                var confirmationNumber = $('#hdnConfirmationNumber').val();

                // Client-side validation: ensure all cascading dropdowns have selections
                var loanProgram = $("#new-loanprogram").val();
                var downPayment = $("#new-downpayment option:selected").val();
                var ficoScore = $("#new-fico option:selected").val();

                if (!loanProgram || !downPayment || !ficoScore) {
                    $('#featured_error_message')
                        .text('Please select loan program, down payment, and FICO score.')
                        .removeClass('d-none');
                    return;
                }

                $('#featured_error_message').addClass('d-none');
                $('#featured_update_error_message').addClass('d-none');
                $("#loading-img-featured").removeClass("d-none");
                $('#featured_rate_form').parent().addClass('d-none');
                var postUrl = $(this).attr('id') == 'update_featured'
                    ? `update-featured?loanNumber=${confirmationNumber}&loanprogram=${$("#new-loanprogram").val()}&downpayment=${$("#new-downpayment option:selected").val()}&ficoscore=${$("#new-fico option:selected").text()}&lockrate=${$("#new-fico option:selected").val()}&programCode=${$("#hdnloanprogramcode").val()}`
                    : `update-featured?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        // Update display values immediately to prevent stale data on reload
                        var dpVal = parseFloat($("#new-downpayment option:selected").val());
                        var dpText = !isNaN(dpVal) ? (dpVal * 100).toString() : '';
                        var ficoText = $("#new-fico option:selected").text();
                        var programText = $("#new-loanprogram option:selected").text();

                        if (dpText) $('p:contains("Down Payment:")').html('<b>Down Payment:</b> ' + dpText + ' %');
                        if (ficoText) $('p:contains("FICO Score:")').html('<b>FICO Score:</b> ' + ficoText);
                        if (programText) $('p:contains("Loan Program:")').html('<b>Loan Program:</b> ' + programText);

                        $("#loading-img-featured").addClass("d-none");
                        // Small delay to ensure DB commit completes before reload
                        setTimeout(function() { location.reload(); }, 500);
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 0 || jqXHR.status === 502 || jqXHR.status === 503 || jqXHR.status === 504 || textStatus === 'timeout') {
                            var el = $('#featured_update_error_message');
                            el.text('The update is taking longer than expected. Your changes may have been saved \u2014 please refresh the page to check.');
                            el.removeClass('d-none').removeClass('alert-danger').addClass('alert-warning');
                        } else {
                            $('#featured_update_error_message').removeClass('d-none');
                        }
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });
            });

            $('#revert_featured').click(function (e) {
                e.preventDefault();
                var confirmationNumber = $('#hdnConfirmationNumber').val();

                $("#loading-img-featured").removeClass("d-none");
                $('#featured_update_error_message').addClass('d-none');
                $('#featured_rate_form').parent().addClass('d-none');
                var postUrl = $(this).attr('id') == 'revert_featured'
                    ? `revert-featured?loanNumber=${confirmationNumber}`
                    : `revert-featured?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#featured_update_error_message').removeClass('d-none');
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });

                $("#loading-img-featured").addClass("d-none");
            });

            $('[data-programs] input').on('change', function (e) {
                $('#update_programs').prop('disabled', false);
            });

            $('#update_programs').on('click', function (e) {
                $('#loading-img-programs').removeClass('d-none');
                $('#update_programs_error_message').addClass('d-none');
                $('[data-programs]').parent().addClass('d-none');

                var programList = [];
                $('[data-programs] input:checked').each(function () {
                    programList.push($(this).val());
                });

                var confirmation = $('#hdnConfirmationNumber').val();

                $.ajax({
                    url: location.origin + location.pathname.replace('confirmation', 'update-program-list?confirmationNumber=') + confirmation,
                    type: 'POST',
                    contentType: 'text/plain',
                    data: programList.join(','),
                    success: function (response) {
                        location.reload();
                    }
                }).done(function (data, textStatus, jqXHR) {
                    location.reload();
                })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 0 || jqXHR.status === 502 || jqXHR.status === 503 || jqXHR.status === 504 || textStatus === 'timeout') {
                            var el = $('#update_programs_error_message');
                            el.text('The update is taking longer than expected. Your changes may have been saved \u2014 please refresh the page to check.');
                            el.removeClass('d-none').removeClass('alert-danger').addClass('alert-warning');
                        } else {
                            $('#update_programs_error_message').removeClass('d-none');
                        }
                        $('#loading-img-programs').addClass('d-none');
                        $('[data-programs]').parent().removeClass('d-none');
                    });
            });

            // Initialize SignalR for video status updates
            var videoStatusHub = null;
            var confirmationNumber = $('#hdnConfirmationNumber').val();
            var handlersRegistered = false;

            // Helper function to create SignalR instance (but not initialize connection yet)
            function createVideoSignalR() {
                if (!videoStatusHub) {
                    videoStatusHub = new LockCollateralStatusSignalR(confirmationNumber, builderSpecVideoGenerationTimeout);
                }
                return videoStatusHub;
            }

            // Helper function to initialize SignalR connection (call AFTER handlers registered)
            async function initializeVideoSignalRConnection() {
                if (videoStatusHub && !videoStatusHub.isConnected()) {
                    await videoStatusHub.initialize();
                }
                return videoStatusHub;
            }

            // Helper function to register all video handlers
            function registerVideoHandlers() {
                if (handlersRegistered) {
                    return;
                }


                // Register property/custom video handler if pending
                if ($('#property_video').length) {
                    videoStatusHub.registerVideoHandler(
                        'custom',
                        // On success
                        function(data) {

                            // Validate data before updating UI (check for ERROR prefix)
                            if (!data.videoUrl || !data.thumbnailUrl) {
                                console.warn('Property video data incomplete:', data);
                                $('#property_video_loading').addClass('d-none');
                                $('#instructions-div').removeClass('d-none');
                                $('#instructions-div p').text('Video is still processing. Please refresh the page in a moment.').addClass('upload-info');
                                return;
                            }

                            // Check for ERROR strings in URLs
                            if (data.videoUrl.startsWith('ERROR:') || data.thumbnailUrl.startsWith('ERROR:')) {
                                console.error('Property video generation failed:', data);
                                $('#property_video_loading').addClass('d-none');
                                $('#instructions-div').removeClass('d-none');
                                $('#instructions-div p').text('Video generation encountered an error. Please contact support.').addClass('upload-error');
                                $('#property_video').removeClass('pending');
                                return;
                            }

                            // Update UI directly from SignalR data - no AJAX call needed!
                            var $thumbnail = $('#property_video [data-role="thumbnail"]');
                            var cacheBuster = new Date().getTime();
                            var finalThumbnail = data.thumbnailUrl;
                            if (finalThumbnail && !finalThumbnail.includes('?')) {
                                finalThumbnail += '?cb=' + cacheBuster;
                            } else if (finalThumbnail) {
                                finalThumbnail += '&cb=' + cacheBuster;
                            }

                            $thumbnail.attr('data-src', finalThumbnail);
                            $thumbnail.css('background-image', 'url("' + finalThumbnail + '")');

                            $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                            $('#property_video').removeClass('pending');
                            $('#property_video_loading').addClass('d-none');

                            // Set download URL if provided
                            if (data.downloadUrl) {
                                $('[download="CustomVideo"]').attr('href', data.downloadUrl);
                                $('[download="CustomVideo"]').parent().removeClass('d-none');
                            }

                            new VideoPlayer();

                            // Set QR code URL if provided
                            if (data.qrCodeUrl) {
                                // qrCodeUrl is the raw Cloudinary PNG — use directly as img src.
                                // qrCodeDownloadUrl is the same-origin proxy URL — use for the download anchor.
                                $('#property_video_qr').attr('src', data.qrCodeUrl);
                                $('#property_video_qr').removeClass('d-none');
                                $('#property_video_qr_loading').addClass('d-none');

                                var qrSpecDownload = (data.qrCodeDownloadUrl && data.qrCodeDownloadUrl.length > 0) ? data.qrCodeDownloadUrl : null;
                                if (qrSpecDownload) {
                                    $('[download="VideoQRCode"]').attr('href', qrSpecDownload).removeClass('disabled').css('pointer-events', '');
                                    $('[download="VideoQRCode"]').parent().removeClass('d-none');
                                }
                            }

                            $('#instructions-div').addClass('d-none');
                        },
                        // On timeout
                        function(videoType) {
                            $('#property_video_loading').addClass('d-none');
                            $('#instructions-div').removeClass('d-none');
                            $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                        },
                        // On error
                        function(error) {
                            console.error('Property video error:', error);
                            $('#property_video_loading').addClass('d-none');
                            var errorText = error.errorMessage || 'Unable to generate customized video. Please try again.';
                            $('#instructions-div').removeClass('d-none');
                            $('#instructions-div p').text(errorText).addClass('upload-error');
                            $('#property_video').removeClass('pending');
                            $('#property_video_qr_loading').addClass('d-none');
                        }
                    );
                }

                // Register educational/social video handler if pending
                if ($('#educational_video').length) {
                    videoStatusHub.registerVideoHandler(
                        'social',
                        // On success
                        function(data) {

                            // Validate data before updating UI (check for ERROR prefix)
                            if (!data.videoUrl || !data.thumbnailUrl) {
                                console.warn('Educational video data incomplete:', data);
                                $('#educational_video_loading').addClass('d-none');
                                $('#instructions-edu-div').removeClass('d-none');
                                $('#instructions-edu-div p').text('Video is still processing. Please refresh the page in a moment.').addClass('upload-info');
                                return;
                            }

                            // Check for ERROR strings in URLs
                            if (data.videoUrl.startsWith('ERROR:') || data.thumbnailUrl.startsWith('ERROR:')) {
                                console.error('Educational video generation failed:', data);
                                $('#educational_video_loading').addClass('d-none');
                                $('#instructions-edu-div').removeClass('d-none');
                                $('#instructions-edu-div p').text('Video generation encountered an error. Please contact support.').addClass('upload-error');
                                $('#educational_video').removeClass('pending');
                                return;
                            }

                            // Update UI directly from SignalR data - no AJAX call needed!
                            var $thumbnail = $('#educational_video [data-role="thumbnail"]');
                            var cacheBuster = new Date().getTime();
                            var finalThumbnail = data.thumbnailUrl;
                            if (finalThumbnail && !finalThumbnail.includes('?')) {
                                finalThumbnail += '?cb=' + cacheBuster;
                            } else if (finalThumbnail) {
                                finalThumbnail += '&cb=' + cacheBuster;
                            }

                            $thumbnail.attr('data-src', finalThumbnail);

                            $('#educational_video [data-role="play-button"]').attr('href', data.videoUrl);
                            $('#educational_video').removeClass('pending');
                            $('#educational_video_loading').addClass('d-none');

                            // Force reflow so element has computed dimensions before setting background-image
                            // (background-image won't render correctly if set while element is display:none)
                            $('#educational_video')[0].offsetHeight;
                            $thumbnail.css('background-image', 'url("' + finalThumbnail + '")');

                            // Set download URL if provided
                            if (data.downloadUrl) {
                                $('[download="CustomVideo1"]').attr('href', data.downloadUrl);
                                $('[download="CustomVideo1"]').parent().removeClass('d-none');
                            }

                            new VideoPlayer();

                            $('#instructions-edu-div').addClass('d-none');
                        },
                        // On timeout
                        function(videoType) {
                            $('#educational_video_loading').addClass('d-none');
                            $('#instructions-edu-div').removeClass('d-none');
                            $('#instructions-edu-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                        },
                        // On error
                        function(error) {
                            console.error('Educational video error:', error);
                            $('#educational_video_loading').addClass('d-none');
                            var errorText = error.errorMessage || 'Unable to generate customized video. Please try again.';
                            $('#instructions-edu-div').removeClass('d-none');
                            $('#instructions-edu-div p').text(errorText).addClass('upload-error');
                            $('#educational_video').removeClass('pending');
                        }
                    );
                }

                handlersRegistered = true;
            }

            // Database polling fallback - kicks in if SignalR fails or notifications are missed
            var pollingInterval = null;

            function startPollingFallback() {
                if (pollingInterval) {
                    return;
                }

                var pollDelay = 10000; // Start at 10s
                var maxDelay = 60000;  // Max 60s between polls
                var maxRetries = 12;   // ~5 minutes total
                var retryCount = 0;
                var consecutiveErrors = 0;

                function poll() {
                    var hasPending = $('#property_video.pending, #educational_video.pending').length > 0;

                    if (!hasPending || retryCount >= maxRetries) {
                        pollingInterval = null;
                        return;
                    }

                    retryCount++;
                    $.ajax({
                        url: window.location.pathname + '/get-video-status',
                        type: 'GET',
                        data: { confirmationNumber: confirmationNumber },
                        timeout: 15000,
                        success: function(response) {
                            consecutiveErrors = 0;
                            pollDelay = 10000; // Reset delay on success
                            if (response) {
                                updateVideosFromPolling(response);
                            }
                            pollingInterval = setTimeout(poll, pollDelay);
                        },
                        error: function(xhr, status, error) {
                            consecutiveErrors++;
                            console.warn('Polling failed (attempt ' + retryCount + ', consecutive errors: ' + consecutiveErrors + '):', error);
                            // Exponential backoff: double delay on each consecutive error, cap at maxDelay
                            pollDelay = Math.min(pollDelay * 2, maxDelay);
                            pollingInterval = setTimeout(poll, pollDelay);
                        }
                    });
                }

                pollingInterval = setTimeout(poll, pollDelay);
            }

            function updateVideosFromPolling(response) {
                // Update property video if ready and still pending
                if (response.propertyVideo && $('#property_video').is('.pending')) {
                    updateVideoUI('custom', response.propertyVideo);
                }

                // Update social/educational video if ready and still pending
                if (response.socialVideo && $('#educational_video').is('.pending')) {
                    updateVideoUI('social', response.socialVideo);
                }
            }

            function updateVideoUI(videoType, data) {
                // Skip if video URL starts with ERROR
                if (data.videoUrl && data.videoUrl.startsWith('ERROR:')) {
                    console.warn(videoType + ' video has error:', data.videoUrl);
                    var elPrefix = (videoType === 'custom' ? 'property' : 'educational');
                    $('#' + elPrefix + '_video').removeClass('pending');
                    $('#' + elPrefix + '_video_loading').addClass('d-none');
                    return;
                }

                // Skip if thumbnail URL starts with ERROR
                if (data.thumbnailUrl && data.thumbnailUrl.startsWith('ERROR:')) {
                    console.warn(videoType + ' thumbnail has error:', data.thumbnailUrl);
                    var elPrefix = (videoType === 'custom' ? 'property' : 'educational');
                    $('#' + elPrefix + '_video').removeClass('pending');
                    $('#' + elPrefix + '_video_loading').addClass('d-none');
                    return;
                }

                if (videoType === 'custom') {
                    var $thumbnail = $('#property_video [data-role="thumbnail"]');
                    var cacheBuster = new Date().getTime();
                    var finalThumbnail = data.thumbnailUrl;
                    if (finalThumbnail && !finalThumbnail.includes('?')) {
                        finalThumbnail += '?cb=' + cacheBuster;
                    } else if (finalThumbnail) {
                        finalThumbnail += '&cb=' + cacheBuster;
                    }

                    $thumbnail.attr('data-src', finalThumbnail);
                    $thumbnail.css('background-image', 'url("' + finalThumbnail + '")');

                    $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                    $('#property_video').removeClass('pending');
                    $('#property_video_loading').addClass('d-none');

                    if (data.downloadUrl) {
                        $('[download="CustomVideo"]').attr('href', data.downloadUrl);
                        $('[download="CustomVideo"]').parent().removeClass('d-none');
                    }

                    if (data.qrCodeUrl) {
                        // qrCodeUrl is the raw Cloudinary PNG — use directly as img src.
                        // qrCodeDownloadUrl is the same-origin proxy URL — use for the download anchor.
                        $('#property_video_qr').attr('src', data.qrCodeUrl);
                        $('#property_video_qr').removeClass('d-none');
                        $('#property_video_qr_loading').addClass('d-none');

                        var qrSpecDownloadFallback = (data.qrCodeDownloadUrl && data.qrCodeDownloadUrl.length > 0) ? data.qrCodeDownloadUrl : null;
                        if (qrSpecDownloadFallback) {
                            $('[download="VideoQRCode"]').attr('href', qrSpecDownloadFallback).removeClass('disabled').css('pointer-events', '');
                            $('[download="VideoQRCode"]').parent().removeClass('d-none');
                        }
                    }

                    $('#instructions-div').addClass('d-none');
                    new VideoPlayer();
                } else if (videoType === 'social') {
                    var $thumbnail = $('#educational_video [data-role="thumbnail"]');
                    var cacheBuster = new Date().getTime();
                    var finalThumbnail = data.thumbnailUrl;
                    if (finalThumbnail && !finalThumbnail.includes('?')) {
                        finalThumbnail += '?cb=' + cacheBuster;
                    } else if (finalThumbnail) {
                        finalThumbnail += '&cb=' + cacheBuster;
                    }

                    $thumbnail.attr('data-src', finalThumbnail);
                    $thumbnail.css('background-image', 'url("' + finalThumbnail + '")');

                    $('#educational_video [data-role="play-button"]').attr('href', data.videoUrl);
                    $('#educational_video').removeClass('pending');
                    $('#educational_video_loading').addClass('d-none');

                    if (data.downloadUrl) {
                        $('[download="CustomVideo1"]').attr('href', data.downloadUrl);
                        $('[download="CustomVideo1"]').parent().removeClass('d-none');
                    }

                    $('#instructions-edu-div').addClass('d-none');
                    new VideoPlayer();
                }
            }

            // Initialize SignalR if there are pending videos
            if ($('#property_video').is('.pending') || $('#educational_video').is('.pending')) {

                // STEP 1: Create SignalR instance (but don't connect yet)
                createVideoSignalR();

                // STEP 2: Register handlers BEFORE connection/subscription
                // This ensures handlers exist in memory before any notifications can arrive
                registerVideoHandlers();

                // STEP 3: Now initialize the connection and subscribe
                initializeVideoSignalRConnection()
                    .then(() => {

                        // Start polling fallback after 30 seconds if SignalR hasn't delivered
                        setTimeout(startPollingFallback, 30000);
                    })
                    .catch((error) => {
                        console.error('SignalR initialization failed, starting polling fallback immediately:', error);
                        // Start polling immediately if SignalR fails
                        startPollingFallback();
                    });
            } else {
            }

            // Clean up SignalR connection and polling when leaving page
            $(window).on('beforeunload', function() {
                if (videoStatusHub) {
                    videoStatusHub.stop();
                }
                if (pollingInterval) {
                    clearInterval(pollingInterval);
                }
            });

            if ($('#reorder_signrider').length) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap2';
                script.async = true;
                document.body.appendChild(script);

                $('[data-toggle="tooltip"]').tooltip();

                $('#reorder_signrider').on('click', function () {
                    $('#signrider_reorder_dialog').addClass('show');
                });

                $('#signrider_newaddress').on('change', function () {
                    $('#signrider_address_form').toggleClass('active');
                    $('.pac-container').css('z-index', '10001');
                });

                $('#cancel_reorder').on('click', function () {
                    $('#address_form_error, #signrider_order_error').addClass('d-none');

                    $('#street_number').val('');
                    $('#route').val('');
                    $('#locality').val('');
                    $('#administrative_area_level_1').val('');
                    $('#postal_code').val('');

                    $('#signrider_reorder_dialog').removeClass('show');

                    $("#signrider_newaddress").prop("checked", false);
                    $('#signrider_address_form').removeClass('active');
                });

                $('#confirm_reorder').on('click', function () {
                    $('#signrider_order_error').addClass('d-none');

                    if ($('#signrider_newaddress').is(':checked')) {
                        var streetNumber = $('#street_number').val();
                        var streetName = $('#route').val();
                        var city = $('#locality').val();
                        var state = $('#administrative_area_level_1').val();
                        var zip = $('#postal_code').val();

                        if (!streetNumber.length || !streetName.length || !city.length || !state.length || !zip.length) {
                            $('#address_form_error').text('Please enter a valid shipping address').removeClass('d-none');
                            return;
                        }
                    }

                    $.post({
                        url: "reorder-yard-sign?confirmation=" + $('#hdnConfirmationNumber').val(),
                        data: { streetNumber, streetName, city, state, zip },
                        beforeSend: function () {
                            $('.dialog-content, .dialog-buttons').addClass('d-none');
                            $('.dialog-loading').removeClass('d-none');
                        }
                    })
                        .done(function () {
                            $('#success_message, #close_reorder').removeClass('d-none');
                            $('#cancel_reorder, #confirm_reorder').addClass('d-none');
                            $('.dialog-content').children().not('#success_message').addClass('d-none');
                        })
                        .fail(function () {
                            $('#address_error').removeClass('d-none');
                            $('#signrider_order_error').removeClass('d-none').children().first().text('Unable to place new sign rider order. Please try again.');
                        })
                        .always(function () {
                            $('.dialog-content, .dialog-buttons').removeClass('d-none');
                            $('.dialog-loading').addClass('d-none');
                        });
                });

                $('#autocomplete').bind("cut copy paste", function (e) {
                    e.preventDefault();
                });

                $('#close_reorder').on('click', function () {
                    $('#signrider_reorder_dialog').removeClass('show');
                    $('#reorder_signrider').parent().addClass('d-none');
                });
            }
        });
    }
});